// app-modal.component.ts
import { Component, Input, Output, EventEmitter, OnInit, Inject, AfterViewInit } from '@angular/core';
import {_} from '../../../js/globals.js';
import { ModalDataService } from '../../services/modal-data.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector: 'mysynch-modal',
  templateUrl:"../app/modals/mysynch-modal/mysynch-modal.view.html",
  styleUrls: ['../app/modals/mysynch-modal/mysynch-modal.style.css'],
})
export class MysynchModalComponent implements OnInit, AfterViewInit {
  protected title:string = 'Confirmation';
  protected message:string = 'Are you sure?';
  protected withBlur: boolean = false;
  protected showModal:boolean = false;

  protected closeModalDataTmpl: CloseModalData = {error:null,data:null};

  protected performanceContext: PerformanceContext | null = null;

  @Input() configuration: any = {};
  @Input() customData: any;
  @Output() closeModal = new EventEmitter<{ error: any; data: any }>(); // Emit an object with error and data properties

  constructor(@Inject('MySynchFactory') protected MSF: any,
              @Inject('ApiFactory') protected api: any,
              @Inject(ModalDataService) protected modalDataService: ModalDataService,
              @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService,
              @Inject(PerformanceMetricsService) protected perfMetricSvc: PerformanceMetricsService,
              @Inject(PerformanceContextService) protected perfContextSvc: PerformanceContextService
            ) {
                
              }

    ngOnInit() {
        this.performanceContext = this.perfContextSvc.createPerformanceContext();
        this.perfMetricSvc.startTiming("Component:MysynchModal:Render");
        this.title = _.get(this.configuration,'title',this.title);
        this.message = _.get(this.configuration,'message',this.message);
        this.withBlur = _.get(this.configuration,'withBlur',this.withBlur);
        this.showModal =  _.get(this.configuration,'showModal',this.showModal);
    }
  ngAfterViewInit() {
      this.MSF.ready(()=>{
         this.perfMetricSvc.endTiming("component","Component:MysynchModal:Render", this.performanceContext);
      });
  }

  onConfirm() {
    var error: any = null;
    var data: any = null;
    this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); // Emit the event with error and data
   
  }
  onCancel() {
    this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); // Just emit the event without any data
  }
}

 class CloseModalData{
  error: any;
  data: any;
 }